import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import { getStatusColor } from '../../utils/scanReportUtils';

/**
 * StatusChip renders a color-coded MUI Chip for any status string.
 * Automatically maps known statuses to appropriate colors and labels.
 *
 * @param {Object} props
 * @param {string} props.status - Raw status string (e.g. "DEDUP_AND_PUBLISH_COMPLETE")
 * @param {string} [props.label] - Override the auto-generated label
 * @param {string} [props.size] - MUI Chip size ('small' | 'medium')
 * @param {string} [props.variant] - MUI Chip variant ('filled' | 'outlined')
 * @param {Object} [props.sx] - Additional MUI sx styles
 */
const StatusChip = ({ status, label, size = 'small', variant = 'filled', sx = {}, ...rest }) => {
  const { color, label: defaultLabel } = getStatusColor(status);

  return (
    <Chip
      label={label || defaultLabel}
      color={color}
      size={size}
      variant={variant}
      sx={sx}
      {...rest}
    />
  );
};

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['filled', 'outlined']),
  sx: PropTypes.object,
};

export default StatusChip;